<template>
    <div v-if="hasComponenteValido" class="wrapper-form-campo-preenchivel">
        <div class="control">
            <component :is="componenteTipo" :pHasAnexos="pHasAnexos" :pSocios="sociosList" :pEmpresa="pEmpresa" :pCampo="campo" :pSocioEmPreenchimento="pSocioEmPreenchimento" :isPreenchimento="isPreenchimento || isCampoListagemSocio" :pPreview="!isPreenchimento && !isCampoListagemSocio" :pIsConferencia="pIsConferencia" @update:form-data="setValueCampoPadrao" @update:value="setValue" @set:validacao="$event => setValidacao($event, campo)" :required="campo.obrigatorio" :pIsDirty="isForcedDirty" @edit:socio="emitEdicaoSocio"></component>
        </div>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  import { tipoInputEnum, tipoInputPadraoEnum } from '../../CampoForm/enum/TipoInput.enum';
  import CampoPersonalizado from '../../CampoForm/models/campoPersonalizado.model';
  
  export default {
    name: 'TrfCampoPreenchivel',
    emits: ['update:value', 'update:campo-padrao', 'set:validacao', 'edit:socio'],
    components: {
        TrfInputParagrafo: defineAsyncComponent(() => import('../../CampoForm/components/InputParagrafo.vue')),
        TrfPreenchimentoMultiplaEscolha: defineAsyncComponent(() => import('./InputMultiplaEscolhaPreenchimento.vue')),
        TrfPreenchimentoCaixaDeSelecao: defineAsyncComponent(() => import('./InputCaixaDeSelecaoPreenchimento.vue')),
        TrfPreenchimentoListaSuspensa: defineAsyncComponent(() => import('./InputListaSuspensaPreenchimento.vue')),
        TrfBlocoNomeFantasia: defineAsyncComponent(() => import('../../CampoForm/components/BlockNomeFantasia.vue')),
        TrfBlocoNomeEmpresarial: defineAsyncComponent(() => import('../../CampoForm/components/BlockNomeEmpresarial.vue')),
        TrfBlocoEnderecoEmpresarial: defineAsyncComponent(() => import('../../CampoForm/components/BlockEnderecoEmpresarial.vue')),
        TrfBlocoDadosComplementares: defineAsyncComponent(() => import('../../CampoForm/components/BlockDadosComplementares.vue')),
        TrfBlocoSocios: defineAsyncComponent(() => import('../../CampoForm/components/BlockSocios.vue')),
        TrfBlocoSocioDados: defineAsyncComponent(() => import('../../CampoForm/components/BlockSocioDados.vue')),
        TrfBlocoSocioDadosComplementares: defineAsyncComponent(() => import('../../CampoForm/components/BlockSocioDadosComplementares.vue')),
        TrfBlocoIptuEmpresarial: defineAsyncComponent(() => import('../../CampoForm/components/BlockIptuEmpresarial.vue')),
        TrfBlocoSocioTipo: defineAsyncComponent(() => import('../../CampoForm/components/BlockSocioTipo.vue')),
        TrfBlocoEnderecoSocio: defineAsyncComponent(() => import('../../CampoForm/components/BlockEnderecoSocio.vue')),
        TrfBlocoSocioContato: defineAsyncComponent(() => import('../../CampoForm/components/BlockSocioContato.vue')),
        TrfBlocoAnexos: defineAsyncComponent(() => import('../../CampoForm/components/BlockAnexos.vue')),
        TrfSwitcher: defineAsyncComponent(() => import('../../Checkbox/switcher.vue'))
    },
    props: {
        pEmpresa: {
            type: Object,
            default: () => {}
        },
        pSocioEmPreenchimento: {
            type: Object,
            default: () => {}
        },
        pCampo: {
            type: Object,
            default: new CampoPersonalizado()
        },
        pHasAnexos: {
            type: Boolean,
            default: false
        },
        pIsConferencia: {
            type: Boolean,
            default: false
        },
        isPreenchimento: {
            type: Boolean,
            default: false
        },
        isForcedDirty: {
            type: Boolean,
            default: false
        }
    },
    data() {
      return {
        campo: this.pCampo,
        formData: {
            respostaTexto: '',
            respostaTextoHtml: '',
            respostaOpcoes: [],
            respostasSocios: []
        }
      };
    },
    computed: {
        componenteTipo() {
            let componentName = 'div';
            if(!this.campo?.tipoInput) return componentName;

            if(this.campo.blocoPadrao) {
                componentName = tipoInputPadraoEnum.getByKey(this.campo.tipoInput).getComponentePreenchimento()
            } else {
                componentName = tipoInputEnum.getByKey(this.campo.tipoInput).getComponentePreenchimento()
            }
            return componentName;
        },
        sociosList() {
            if (!this.pEmpresa) return []
            return this.pEmpresa.socios
        },
        isCampoListagemSocio() {
            return this.componenteTipo == tipoInputPadraoEnum.getByKey("ADICIONAR_SOCIO").getComponentePreenchimento()
        },
        hasComponenteValido() {
            return this.componenteTipo != null
        }
    },
    watch: {
        pCampo: {
            immediate: true,
            handler(novo) {
                this.campo = novo
            },
            deep: true
        }
    },
    methods: {
        async setValue(value) {
            if (value) {
                this.formData = {...this.formData, ...value}
            }
            this.emitValue(this.formData)
        },
        setValueCampoPadrao(value) {
            const respostaCampoPadrao = Object.assign({}, this.formData.respostaCampoPadrao, value);
            this.formData.respostaCampoPadrao = respostaCampoPadrao;
            this.emitCampoPadrao(this.formData)
        },
        setValidacao(status, campo) {
            this.$emit('set:validacao', {
                campo: campo,
                isValido: status
            })
        },
        emitCampoPadrao(formData) {
            this.$emit('update:campo-padrao', formData)
        },
        emitValue(value) {
            this.$emit('update:value', value)
        },
        emitEdicaoSocio(opcoesSocio) {
            this.$emit('edit:socio', opcoesSocio)
        }
    }
  };
  </script>
  <style lang="scss" scoped>
    .control {
        font-size: inherit
    }
  </style>